import React, { Component } from "react";
import '../navigation.css';

export class Navigation extends Component {
  render() {
    return (
      <nav id="menu" className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
            >
              {" "}
              <span className="sr-only">Toggle navigation</span>{" "}
              <span className="icon-bar"></span>{" "}
              <span className="icon-bar"></span>{" "}
              <span className="icon-bar"></span>{" "}
            </button>
            <a className="navbar-brand page-scroll brand-logo" href="#page-top">
              <img src="./img/old-logo.png" alt="Lesson on Golf logo" />
            </a>{" "}
          </div>

          <div
            className="collapse navbar-collapse"
            id="bs-example-navbar-collapse-1"
          >
            <ul className="nav navbar-nav navbar-right">
              <li>
                <a href="https://lessongolf.myshopify.com/" target="_blank"
                  rel="noopener noreferrer" className="page-scroll">
                  Shop
                </a>
              </li>
              <li>
                <a href="#features" className="page-scroll">
                  Featured Deals
                </a>
              </li>
              <li>
                <a href="#services" className="page-scroll">
                  X
                </a>
              </li>
              <li>
                <a href="#about" className="page-scroll">
                  About
                </a>
              </li>
              <li>
                <a href="#sponsors" className="page-scroll">
                  Sponsors
                </a>
              </li>
              <li>
                <a href="#contact" className="page-scroll">
                  Contact
                </a>
              </li>
              <li className="yt-nav-item">
                <a
                  href="#youtube"
                  className="page-scroll yt-nav-link"
                  aria-label="Lesson on Golf YouTube"
                >
                  <i className="fa fa-youtube-play"></i>
                  <span>YouTube</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navigation;
